/**
 * In external evaluations, subject name is injected into question copy.
 * TEMP: also replaces mistaken `{Username}}` from a bad config save. Remove
 * this branch once we have bulk question updates or the stored text is fixed.
 */
export function applyExternalEvalSubjectNameInQuestionText(text, creatorName) {
  if (!text || !creatorName) return text;
  return text
    .replaceAll('§USER_NAME§', creatorName)
    .replaceAll('{Username}}', creatorName);
}
